<script lang="ts">
    import FaTimes from 'svelte-icons/fa/FaTimes.svelte';
    import FaCheck from 'svelte-icons/fa/FaCheck.svelte';

    export let checked = false;
</script>

<div class="toggle-switch-wrapper">
    <slot name="switch-text"></slot>
    <label for="toggleBtn">
        <input type="checkbox" name="toggleBtn" id="toggleBtn" bind:checked>
        <div class="toggler">
            <div class="tick"><FaCheck /></div>
            <div class="cross"><FaTimes /></div>
            <div class="togglerSlider"></div>
        </div>
    </label>
</div>

<style lang="scss">
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

.toggle-switch-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 30px;
}

/* Checkbox Slider */
.toggler {
    display: flex;
    flex-direction: row;
    height: 24px;
    width: 48px;
    background-color: rgb(238, 176, 176);
    border-radius: 12px;
    cursor: pointer;
    position: relative;
    transition: background-color 0.4s;
    margin-left: 10px;
}

.cross, .tick {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 12px;
    height: 12px;
    background-color: transparent;
    border-radius: 50%;
    margin: auto;
}
.tick {
    color: var(--color-primary);
    opacity: 0;
    transition: opacity 0.4s;
}
.cross {
    color: var(--color-tertiary);
    opacity: 1;
    transition: opacity 0.4s;
}
.togglerSlider {
    display: block;
    height: 20px;
    width: 20px;
    background-color: var(--color-gray);
    border-radius: 50%;
    position: absolute;
    left: 2px;
    top: 2px;
    z-index: 5;
    transition: left 0.4s;
}

/* Checked Actions */
#toggleBtn:checked + .toggler .togglerSlider {
    left: 26px;
}
#toggleBtn:checked + .toggler {
    background-color: rgb(190, 241, 196);
}
#toggleBtn:checked + .toggler .tick {
    opacity: 1;
}
#toggleBtn:checked + .toggler .cross {
    opacity: 0;
}
#toggleBtn {
    display: flex;
    appearance: none;
    align-items: center;
}

</style>